<template>
  <div>
    <action-header
      v-if="!hasValidRole(role, [Role.Student, Role.Family])"
      :button="buttonSearch"
      :data.sync="studentCode"
      @studentValue="studentCode = $event"
      :pathConnect="pathConnect"
      @export-pdf="exportPdf()"
      :show-export="showExport"
      ref="actionHeader"
    >
    </action-header>
    <div v-else class="md-layout hidden lg:block">
      <div class="md-layout-item text-right">
        <md-button
          class="md-warning"
          @click.prevent="exportPdf()"
          v-if="showExport"
        >
          {{ $t("common.export") }}
        </md-button>
      </div>
    </div>

    <student-information :data="infoStudent">
      <md-card class="rounded-xl">
        <md-card-header class=" md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("smi_sri.sat_detail") }}</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div v-if="satScoreTable.length">
            <div class="md-layout-item md-size-100 mb-10">
              <chart :chartData="chartData"></chart>
            </div>

            <div class="md-layout-item md-size-100">
              <div class="flex justify-between mb-2">
                <span class="font-medium">
                  {{
                    $t("smi_sri.total_tests_taken", {
                      length: chartData.labels.length
                    })
                  }}
                </span>
                <span class="text-right text-red-600 text-sm">
                  {{ $t("smi_sri.super_score") }}:
                  <span class="font-medium">{{ superScore }}</span>
                </span>
              </div>
              <md-table class="sat-table">
                <md-table-row class="text-center">
                  <md-table-head>
                    {{ $t("smi_sri.test_name") }}
                  </md-table-head>
                  <md-table-head>{{ $t("smi_sri.test_date") }}</md-table-head>
                  <md-table-head>
                    <div>
                      {{ $t("smi_sri.total_score_1600") }}
                    </div>
                  </md-table-head>
                  <md-table-head>Reading and Writing (200-800)</md-table-head>
                  <md-table-head>
                    Math (200 - 800)
                  </md-table-head>
                </md-table-row>
                <md-table-row
                  class="text-center"
                  v-for="(info, index) in satScoreTable"
                  :key="info + index"
                >
                  <md-table-cell>{{ info.test_name }}</md-table-cell>
                  <md-table-cell
                    >{{ convertDateFromServer(info.test_date, "date") }}
                  </md-table-cell>
                  <md-table-cell>{{ info.total_score }}</md-table-cell>
                  <md-table-cell>{{ info.reading_and_writing }}</md-table-cell>
                  <md-table-cell>{{ info.math }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>

            <div v-if="showExport">
              <pdf-default ref="pdfContent" pdf-format="letter">
                <template #pdf-content>
                  <export-pdf-sat
                    :info-student="infoStudent"
                    :chart-data="chartData"
                    :table-data="satScoreTable"
                    :super-score="superScore"
                  ></export-pdf-sat>
                </template>
              </pdf-default>
            </div>
          </div>
          <div v-else>
            <no-data-found class="mx-auto"></no-data-found>
          </div>
        </md-card-content>
      </md-card>
    </student-information>
  </div>
</template>
<script>
import ActionHeader from "./ActionHeader";
import { service_names } from "@/constants/Services";
import StudentInformation from "../Components/StudentInfomation";
import AWSConst from "@/constants/AWS";
import chart from "./Chart";
import { mapGetters, mapState } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { getId, Message } from "@/helpers/utils";
import { convertDateFromServer } from "@/helpers/datetime-helper";
import PdfDefault from "../../../components/PdfDefault";
import ExportPdfSat from "./ExportPdfSat";
import { COLOR_CHART_SAT } from "@/helpers/color-chart-config";

export default {
  components: {
    ExportPdfSat,
    PdfDefault,
    StudentInformation,
    ActionHeader,
    chart
  },
  data() {
    return {
      Role,
      hasValidRole,
      buttonSearch: {
        title: "common.search",
        action: this.getSatInfo
      },
      studentCode: null,
      satScoreTable: [],
      superScore: null,
      infoStudent: null,
      pathConnect: {
        templateLinks: `${service_names.school}/sat/template`,
        templateName: "template-sat.xlsx",
        pathSaveUploadedLink: `${service_names.school}/sat/import`,
        S3ImportACTPath: AWSConst.S3_IMPORT_SAT_PATH
      },
      chartData: {},
      showExport: false,
      convertDateFromServer
    };
  },
  watch: {
    studentCode: function() {
      this.infoStudent = null;
    }
  },
  computed: {
    ...mapState("switchAccountChild", ["currentChild"]),
    ...mapGetters("user", ["role", "info"])
  },
  mounted() {
    if (hasValidRole(this.role, Role.Student)) {
      this.studentCode = getId(this.info);
      this.getSatInfo();
    }

    if (hasValidRole(this.role, Role.Family)) {
      this.studentCode = getId(this.currentChild);
      this.getSatInfo();
    }

    const query = this.$route.query;
    if (!hasValidRole(this.role, Role.Student) && query.tabName === "SAT") {
      this.setInfoStudentByQuery(query);
    }
  },
  methods: {
    setInfoStudentByQuery(query) {
      this.studentCode = query.id;
      this.getSatInfo();
      this.$router.replace({ query: {} });
    },
    getSatInfo() {
      const studentCode = this.studentCode;
      if (!studentCode) {
        Message.error(
          this.$t("smi_sri.please_select_the_student_to_view_report")
        );
        return;
      }
      this.$axios
        .get(`${service_names.school}/user/${studentCode}/report/sat`)
        .then(response => {
          this.infoStudent = {
            fullName: response.data?.full_name,
            studentCode: response.data?.student_code,
            avatarUrl: response.data?.avatar_url,
            grade: response.data?.grade
          };
          if (!hasValidRole(this.role, [Role.Student, Role.Family])) {
            this.$refs.actionHeader.studentData.displayValue =
              this.infoStudent.fullName +
                " - " +
                this.infoStudent.studentCode || "";
          }
          this.setData(response.data);
        });
    },
    getMaxScore(data, key) {
      return Math.max.apply(
        null,
        data.map(function(object) {
          return object[key];
        })
      );
    },
    setData(data) {
      if (!data) return;
      this.satScoreTable = data.sats;
      this.showExport = !!this.satScoreTable.length;
      let labels = [];
      let dataSets = [
        {
          label: "Reading and writing",
          id: "reading_and_writing",
          data: []
        },
        { label: "Math", id: "math", data: [] }
      ];

      //get super score
      this.superScore = dataSets
        .map(item => this.getMaxScore(this.satScoreTable, item.id))
        .reduce((partialSum, a) => partialSum + a, 0);

      //setBarChartData
      this.setBarChartData(this.satScoreTable, labels, dataSets);
    },
    setBarChartData(satScoreTable, labels, dataSets) {
      satScoreTable.forEach(tableData => {
        labels.push(convertDateFromServer(tableData.test_date, "date"));
        dataSets.forEach((_, index) => {
          dataSets[index]?.data.push(tableData[dataSets[index].id]);
        });
      });
      dataSets.forEach((item, index) => {
        item.backgroundColor = COLOR_CHART_SAT[dataSets[index]?.label];
        item.data.reverse();
      });

      //prefix tooltip
      const testName = satScoreTable.map(item => item.test_name);
      const prefixTooltips = [];
      labels.map((date, index) => {
        prefixTooltips.push(`${testName[index]} (${labels[index]})`);
      });

      this.chartData = {
        labels: labels.reverse(),
        datasets: dataSets,
        prefix: prefixTooltips.reverse(),
        isTotal: true
      };
    },
    exportPdf() {
      this.$refs.pdfContent.generatePdf();
    }
  }
};
</script>
<style lang="scss">
.sat-table {
  .md-table-head {
    padding: 12px 8px;
    text-align: center;
    border: 0.5px solid #b8b7b7;

    .md-table-head-container {
      .md-table-head-label {
        padding: 0;
      }
    }
  }

  .md-table-cell {
    border: 0.5px solid #b8b7b7;
  }
}
</style>
